export interface Actress {
  id: number;
  name: string;
  nameJp: string;
  slug: string;
  category: string;
  debutYear: number;
  birthDate: string;
  birthplace: string;
  height: string;
  bloodType: string;
  agency: string;
  imageSeq: string;
  description: string;
  biography: string;
  representativeWorks: string[];
  awards: string[];
  tags: string[];
  featured: boolean;
  hot: boolean;
}

export const actresses: Actress[] = [
  {
    id: 1,
    name: '新垣结衣',
    nameJp: '新垣 結衣',
    slug: 'aragaki-yui',
    category: '影视剧女优',
    debutYear: 2005,
    birthDate: '1988年6月11日',
    birthplace: '日本冲绳县那霸市',
    height: '169cm',
    bloodType: 'A型',
    agency: 'LesPros Entertainment',
    imageSeq: 'actress-aragaki-yui',
    description: '新垣结衣是日本最具人气的女演员之一，以清新自然的形象和精湛的演技深受观众喜爱，被誉为"国民老婆"。',
    biography: '新垣结衣1988年出生于冲绳县，2005年以模特身份出道，随后凭借《龙樱》《父女七日变》等作品崭露头角。2007年主演电影《恋空》一举成名，斩获多项新人奖。此后在《Legal High》《逃避虽可耻但有用》等日剧中展现出色演技，成为日本影视界的中流砥柱。2016年主演的《逃避虽可耻但有用》创下高收视率，片尾曲"恋舞"风靡全日本。她还发行过多张音乐专辑，是多栖发展的全能艺人。',
    representativeWorks: ['逃避虽可耻但有用', 'Legal High', '恋空', 'Code Blue', '掟上今日子的备忘录'],
    awards: ['第61回日剧学院赏最佳女主角', '第50回蓝丝带赏最佳女主角', '第91回日剧学院赏最佳女主角'],
    tags: ['人气女优', '实力派', '冲绳出身', '国民老婆'],
    featured: true,
    hot: true,
  },
  {
    id: 2,
    name: '石原里美',
    nameJp: '石原 さとみ',
    slug: 'ishihara-satomi',
    category: '影视剧女优',
    debutYear: 2003,
    birthDate: '1986年12月24日',
    birthplace: '日本东京都',
    height: '157cm',
    bloodType: 'A型',
    agency: 'Horipro',
    imageSeq: 'actress-ishihara-satomi',
    description: '石原里美是日本顶级女演员，以甜美笑容和百变造型著称，在时尚与影视领域均有极高影响力。',
    biography: '石原里美1986年出生于东京都，2003年通过Horipro艺人选拔出道。早期在《宠物情人》《新娘与爸爸》等剧中积累经验。2009年主演《 Voice ～亡者之声～》获得关注。此后在《富贵男与贫穷女》《朝5晚9》《校阅女孩河野悦子》《非自然死亡》等作品中表现卓越，成为收视率保证。她同时也是时尚Icon，多次登上各大时尚杂志封面，代言无数。2020年宣布结婚后依然保持高人气。',
    representativeWorks: ['非自然死亡', '朝5晚9', '校阅女孩河野悦子', '富贵男与贫穷女', '失恋巧克力职人'],
    awards: ['第96回日剧学院赏最佳女主角', '第11回CONFiDENCE日剧大奖最佳女主角', '东京戏剧奖最佳女主角'],
    tags: ['人气女优', '时尚Icon', '收视女王', '多面手'],
    featured: true,
    hot: true,
  },
  {
    id: 3,
    name: '北川景子',
    nameJp: '北川 景子',
    slug: 'kitagawa-keiko',
    category: '影视剧女优',
    debutYear: 2003,
    birthDate: '1986年8月22日',
    birthplace: '日本兵库县神户市',
    height: '160cm',
    bloodType: 'O型',
    agency: 'Stardust Promotion',
    imageSeq: 'actress-kitagawa-keiko',
    description: '北川景子是日本实力派女演员，以精致五官和强大气场著称，多次获选"日本女性最憧憬的容颜"。',
    biography: '北川景子1986年出生于兵库县神户市，2003年通过Seventeen杂志模特选拔出道。2006年出演电视剧《美少女战士》真人版正式进入演艺圈。此后在《抹布女孩》《零秒出手》《推理要在晚餐后》《HERO》续集等作品中展现扎实演技。2016年与歌手DAIGO结婚，婚后人气不减反增。她多次被评选为"日本女性最想拥有的脸"第一名，是公认的日本顶级美人。',
    representativeWorks: ['推理要在晚餐后', 'HERO 2', '卖房子的女人', '零秒出手', '侦探的侦探'],
    awards: ['第39回日本电影学院奖最佳女主角提名', '第88回日剧学院赏最佳女主角', '美的杂志最憧憬容颜第1名（多次）'],
    tags: ['颜值担当', '实力派', '神户出身', '最憧憬容颜'],
    featured: true,
    hot: false,
  },
  {
    id: 4,
    name: '绫濑遥',
    nameJp: '綾瀬 はるか',
    slug: 'ayase-haruka',
    category: '影视剧女优',
    debutYear: 2000,
    birthDate: '1985年3月24日',
    birthplace: '日本广岛县广岛市',
    height: '165cm',
    bloodType: 'B型',
    agency: 'Horipro',
    imageSeq: 'actress-ayase-haruka',
    description: '绫濑遥是日本国民级女演员，以天然呆形象和扎实演技收获大量粉丝，影视歌三栖发展全面开花。',
    biography: '绫濑遥1985年出生于广岛县，2000年参加Horipro新人选拔获得特别奖出道。2004年凭借《在世界中心呼唤爱》获得日剧学院赏最佳女配角。此后在《萤之光》《仁医》《八重之樱》《继母与女儿的蓝调》等作品中持续输出高质量表演。她也是NHK大河剧《八重之樱》的主演，证明了其国民级女演员的地位。音乐方面也发行过多张单曲和专辑。',
    representativeWorks: ['萤之光', '仁医', '在世界中心呼唤爱', '继母与女儿的蓝调', '天国与地狱'],
    awards: ['第42回日剧学院赏最佳女配角', '第66回日剧学院赏最佳女主角', '第24回桥田赏'],
    tags: ['国民女优', '天然呆', '广岛出身', '全能艺人'],
    featured: true,
    hot: false,
  },
  {
    id: 5,
    name: '长泽雅美',
    nameJp: '長澤 まさみ',
    slug: 'nagasawa-masami',
    category: '影视剧女优',
    debutYear: 2000,
    birthDate: '1987年6月3日',
    birthplace: '日本静冈县磐田市',
    height: '168cm',
    bloodType: 'A型',
    agency: 'Toho Entertainment',
    imageSeq: 'actress-nagasawa-masami',
    description: '长泽雅美是日本实力派女演员，以高挑身材和精湛演技著称，在电影和电视剧领域均有卓越表现。',
    biography: '长泽雅美1987年出生于静冈县，2000年参加东宝"东宝灰姑娘"选拔获得最高奖出道。2004年主演电影《在世界中心呼唤爱》一炮而红，成为日本最受瞩目的年轻女演员。此后在《求婚大作战》《Last Friends》《海街日记》《行骗天下JP》等作品中不断突破自我，从清纯玉女成功转型为实力派演员。她是日本电影学院奖的常客，多次获得最佳女主角和最佳女配角奖项。',
    representativeWorks: ['求婚大作战', '海街日记', '行骗天下JP', 'Last Friends', '在世界中心呼唤爱'],
    awards: ['第39回日本电影学院奖最佳女配角', '第44回日本电影学院奖最佳女主角', '第72回每日电影奖最佳女主角'],
    tags: ['实力派', '东宝灰姑娘', '静冈出身', '电影女王'],
    featured: false,
    hot: true,
  },
  {
    id: 6,
    name: '有村架纯',
    nameJp: '有村 架純',
    slug: 'arimura-kasumi',
    category: '影视剧女优',
    debutYear: 2010,
    birthDate: '1993年2月13日',
    birthplace: '日本兵库县伊丹市',
    height: '160cm',
    bloodType: 'B型',
    agency: 'FLaMme',
    imageSeq: 'actress-arimura-kasumi',
    description: '有村架纯是日本新生代实力派女演员，以清纯可爱的形象走红，演技日益精进备受好评。',
    biography: '有村架纯1993年出生于兵库县，2010年通过FLaMme事务所选拔出道。2013年因出演NHK晨间剧《海女》而受到关注，饰演的少女角色深入人心。2015年主演电影《垫底辣妹》获得巨大成功，提名日本电影学院奖最佳女主角。此后在《追忆潸然》《中学圣日记》《花束般的恋爱》等作品中持续展现成长中的演技实力。她也是2021年NHK晨间剧《Come Come Everybody》的主演之一。',
    representativeWorks: ['垫底辣妹', '花束般的恋爱', '海女', '追忆潸然', '中学圣日记'],
    awards: ['第39回日本电影学院奖最佳女主角提名', '第58回日剧学院赏最佳女主角', '第39回日本电影学院奖新人奖'],
    tags: ['新生代', '清纯派', '兵库出身', '晨间剧女主'],
    featured: false,
    hot: true,
  },
  {
    id: 7,
    name: '桥本环奈',
    nameJp: '橋本 環奈',
    slug: 'hashimoto-kanna',
    category: '偶像女优',
    debutYear: 2013,
    birthDate: '1999年2月3日',
    birthplace: '日本福冈县福冈市',
    height: '152cm',
    bloodType: 'AB型',
    agency: 'Discovery Next',
    imageSeq: 'actress-hashimoto-kanna',
    description: '桥本环奈被誉为"千年一遇的美少女"，从偶像团体成员成功转型为演员，以可爱形象征服全日本。',
    biography: '桥本环奈1999年出生于福冈县，从小以童星身份活动。2013年因一张在活动中的"奇迹的一枚"照片在网络上爆红，被媒体称为"千年一遇的美少女"。此后从偶像团体Rev. from DVL成员逐渐转型为演员。在《银魂》真人版、《我是大哥大》《辉夜大小姐想让我告白》等作品中展现出色的喜剧演技，成功摆脱了单纯的美少女标签，成长为全能型艺人。',
    representativeWorks: ['银魂', '我是大哥大', '辉夜大小姐想让我告白', '王者天下', '午夜0时的吻'],
    awards: ['第43回日本电影学院奖新人奖', '第7回JAPAN ACTION AWARDS最佳动作女演员'],
    tags: ['千年一遇', '偶像出身', '福冈出身', '喜剧天才'],
    featured: true,
    hot: true,
  },
  {
    id: 8,
    name: '滨边美波',
    nameJp: '浜辺 美波',
    slug: 'hamabe-minami',
    category: '新生代女优',
    debutYear: 2011,
    birthDate: '2000年8月29日',
    birthplace: '日本石川县',
    height: '156cm',
    bloodType: 'B型',
    agency: 'Toho Entertainment',
    imageSeq: 'actress-hamabe-minami',
    description: '滨边美波是日本最受瞩目的年轻女演员之一，以清纯美貌和超越年龄的成熟演技获得广泛认可。',
    biography: '滨边美波2000年出生于石川县，2011年参加第7届"东宝灰姑娘"选拔获得新生代奖出道。2017年主演电影《想吃掉你的胰脏》大获成功，获得第42届日本电影学院奖新人奖。此后在《狂赌之渊》《我们有点不对劲》《约定的梦幻岛》等作品中挑战各种类型角色，从青春少女到黑暗角色均有出色表现。她被认为是日本演艺圈最有潜力的年轻女演员之一。',
    representativeWorks: ['想吃掉你的胰脏', '狂赌之渊', '我们有点不对劲', '约定的梦幻岛', '老师你不知道吗'],
    awards: ['第42届日本电影学院奖新人奖', '第43届报知电影奖最佳女主角', '第41届山路文子电影奖最佳女主角'],
    tags: ['新生代', '东宝灰姑娘', '石川出身', '未来之星'],
    featured: false,
    hot: true,
  },
  {
    id: 9,
    name: '永野芽郁',
    nameJp: '永野 芽郁',
    slug: 'nagano-mei',
    category: '新生代女优',
    debutYear: 2009,
    birthDate: '1999年9月24日',
    birthplace: '日本东京都',
    height: '163cm',
    bloodType: 'AB型',
    agency: 'Stardust Promotion',
    imageSeq: 'actress-nagano-mei',
    description: '永野芽郁是日本新生代超人气女演员，以治愈系笑容和出色的哭戏闻名，在年轻观众中拥有极高人气。',
    biography: '永野芽郁1999年出生于东京都，2009年以童星身份出道。2016年在电影《俺物語!!》中饰演女主角获得关注。2018年主演NHK晨间剧《一半，蓝色》大放异彩，创下高收视率。此后在《3年A班》《宠女青春白皮书》《然后，活着》等作品中持续保持高曝光率。她以其独特的治愈气质和自然生动的演技，成为当下日本最受欢迎的新生代女演员之一。',
    representativeWorks: ['一半，蓝色', '3年A班', '宠女青春白皮书', '俺物语!!', '然后，活着'],
    awards: ['第98回日剧学院赏最佳女主角', '第43回日本电影学院奖新人奖', '第31回日本电影评论家大奖最佳女主角'],
    tags: ['新生代', '治愈系', '晨间剧女主', '东京出身'],
    featured: false,
    hot: false,
  },
  {
    id: 10,
    name: '本田翼',
    nameJp: '本田 翼',
    slug: 'honda-tsubasa',
    category: '影视剧女优',
    debutYear: 2006,
    birthDate: '1992年6月27日',
    birthplace: '日本东京都',
    height: '166cm',
    bloodType: 'O型',
    agency: 'Stardust Promotion',
    imageSeq: 'actress-honda-tsubasa',
    description: '本田翼是日本知名女演员兼模特，以清新短发形象和活泼性格走红，在年轻人中拥有广泛影响力。',
    biography: '本田翼1992年出生于东京都，2006年以杂志模特身份出道。2012年首次出演电视剧《恋爱NEET》正式进入演艺圈。此后在《安堂机器人》《闪烁的爱情》《校阅女孩河野悦子》《绝对零度》等作品中积累经验。她同时也是知名游戏爱好者，经常在社交媒体分享游戏日常，拥有庞大的年轻粉丝群体。她还是多个时尚品牌的代言人，在时尚圈也有相当影响力。',
    representativeWorks: ['绝对零度', '校阅女孩河野悦子', '闪烁的爱情', '安堂机器人', '青春侦探晴也'],
    awards: ['第25回日本电影评论家大奖最佳新人奖'],
    tags: ['短发女神', '游戏达人', '模特出身', '东京出身'],
    featured: false,
    hot: false,
  },
  {
    id: 11,
    name: '上白石萌音',
    nameJp: '上白石 萌音',
    slug: 'kamishiraishi-mone',
    category: '新生代女优',
    debutYear: 2011,
    birthDate: '1998年1月27日',
    birthplace: '日本鹿儿岛县',
    height: '152cm',
    bloodType: 'AB型',
    agency: 'Toho Entertainment',
    imageSeq: 'actress-kamishiraishi-mone',
    description: '上白石萌音是日本全能型年轻艺人，以配音演员身份出道后成功转型为演员和歌手，多才多艺深受喜爱。',
    biography: '上白石萌音1998年出生于鹿儿岛县，2011年参加第7届"东宝灰姑娘"选拔获得评委特别奖出道。2016年为电影《你的名字。》女主角宫水三叶配音一炮而红。此后在《恋爱可以持续到天长地久》《Oh! My Boss! 恋爱在别册》等电视剧中担任主演，展现出色演技。她还发行过多张音乐专辑，为多部动画作品演唱主题曲，是真正的多栖艺人。',
    representativeWorks: ['你的名字。', '恋爱可以持续到天长地久', 'Oh! My Boss!', '记忆屋', '家政夫三田园'],
    awards: ['第104回日剧学院赏最佳女主角', '第11回声优奖最佳女主角', '第45回日本电影学院奖新人奖'],
    tags: ['全能艺人', '东宝灰姑娘', '鹿儿岛出身', '声优转演员'],
    featured: false,
    hot: false,
  },
  {
    id: 12,
    name: '今田美樱',
    nameJp: '今田 美桜',
    slug: 'imada-mio',
    category: '新生代女优',
    debutYear: 2015,
    birthDate: '1997年3月5日',
    birthplace: '日本福冈县福冈市',
    height: '158cm',
    bloodType: 'O型',
    agency: 'Contents 3',
    imageSeq: 'actress-imada-mio',
    description: '今田美樱被誉为"福冈最可爱女生"，以甜美外貌和性感身材双重魅力走红，是新生代最炙手可热的写真偶像兼演员。',
    biography: '今田美樱1997年出生于福冈县，2015年以"福冈最可爱女生"选拔走红网络。2016年正式出道，初期以写真偶像和模特活动为主。2018年出演电视剧《花后晴天～花男Next Season～》获得广泛关注。此后在《3年A班》《半泽直树2》《M 为了心爱的人》等热门作品中频频亮相。她以甜美的外貌和日益精进的演技，成为各大广告商争相签约的新生代女神。',
    representativeWorks: ['花后晴天', '3年A班', '半泽直树2', 'M 为了心爱的人', 'Doctor X 7'],
    awards: ['第25回日刊体育日剧大奖最佳女配角', '美的杂志最憧憬容颜TOP10'],
    tags: ['福冈最可爱', '写真偶像', '新生代', '广告女王'],
    featured: false,
    hot: true,
  },
];

export const getActressBySlug = (slug: string): Actress | undefined => {
  return actresses.find(a => a.slug === slug);
};

export const getActressesByCategory = (category: string): Actress[] => {
  return actresses.filter(a => a.category === category);
};

export const getFeaturedActresses = (): Actress[] => {
  return actresses.filter(a => a.featured);
};

export const getHotActresses = (): Actress[] => {
  return actresses.filter(a => a.hot);
};

export const getAllActresses = (): Actress[] => {
  return actresses;
};